import { createRoot } from "react-dom/client";
import App from "./App";
import { AuthProvider } from "./contexts";
import "./index.css";

const APP_VERSION = "1.8.3";

if ("caches" in window && window.localStorage.getItem("linguahome_app_version") !== APP_VERSION) {
  void caches.keys().then((keys) => Promise.all(keys.filter((key) => key.startsWith("linguahome-")).map((key) => caches.delete(key))));
  window.localStorage.setItem("linguahome_app_version", APP_VERSION);
}

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registration = await navigator.serviceWorker.register(`/sw.js?v=${APP_VERSION}`, { scope: "/", updateViaCache: "none" });
      registration.waiting?.postMessage({ type: "SKIP_WAITING" });
      registration.addEventListener("updatefound", () => {
        const worker = registration.installing;
        worker?.addEventListener("statechange", () => {
          if (worker.state === "installed" && navigator.serviceWorker.controller) worker.postMessage({ type: "SKIP_WAITING" });
        });
      });
      void registration.update();
    } catch (error) {
      console.error("Não foi possível registrar o PWA:", error);
    }
  });
}

createRoot(document.getElementById("root")!).render(<AuthProvider><App /></AuthProvider>);
